import {css} from 'lit'; export default css`:host a.macos-support-banner-link{color:var(--goto-type-color-inverted)!important}chameleon-banner{height:32px;position:absolute;width:100%}`;
    